(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .factory('SavedFormValueSearch', SavedFormValueSearch);

    SavedFormValueSearch.$inject = ['$resource'];

    function SavedFormValueSearch($resource) {
        var resourceUrl =  'api/_search/saved-form-values/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
